var _use, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubePink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#youtube-pink_svg__path0_fill",
    fill: "#A51457"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "youtube-pink_svg__path0_fill",
    fillRule: "evenodd",
    d: "M28.206.666a4.01 4.01 0 012.808 2.826c.666 2.484.666 7.668.666 7.668s0 5.184-.648 7.668c-.378 1.386-1.44 2.466-2.808 2.826-2.484.666-12.384.666-12.384.666s-9.9 0-12.366-.666a4.01 4.01 0 01-2.808-2.826C0 16.344 0 11.16 0 11.16s0-5.184.648-7.668c.378-1.386 1.44-2.466 2.808-2.826C5.94 0 15.84 0 15.84 0s9.9 0 12.366.666zM20.88 11.16l-8.28 4.716V6.444l8.28 4.716z"
  }))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/youtube-pink-1d509178eabd6f6877c01bb04d8289fb.svg";
export { SvgYoutubePink as ReactComponent };